// Librerías
import React from "react";
import styled from "styled-components";

// Función para mostrar el spinner
const Spinner = ({ estado }) => {
  //Contiene las props del form anterior

  return (
    //El spinner se mostrará si estado es true
    <>
      {estado && (
        <Overlay>
          <ContenedorModal>{<div className="loader"></div>}</ContenedorModal>
        </Overlay>
      )}
    </>
  );
};

export default Spinner;

// Estilos para el spinner
const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContenedorModal = styled.div`
  width: 400px;
  min-height: 100px;
  position: relative;
  border-radius: 5px;
  box-shadow: rgba(100, 100, 111, 0) 0px 7px 29px 0px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
